<template>
    <div>
        <div class="header">
            <div class="step-ttl">موارد مربوط به بهداشت و درمان</div>
            <div class="h-border"></div>
            <div class="step">مرحله 3-4</div>
        </div>
        <div class="row">
            <div class="col-md-3">
                <div class="form-group">
                    <label>گروه خوني :</label>
                    <input type="text"
                           v-model.trim="healthCareInfo.bloodType"
                           @input="$v.healthCareInfo.bloodType.$touch()"
                           :class="[$v.healthCareInfo.bloodType.$error?'error-input' :'','form-control']">
                    <span class="help-block" v-if="$v.healthCareInfo.bloodType.$error && !$v.healthCareInfo.bloodType.required">لطفا گروه خونی خود را وارد کنید.</span>
                </div>
            </div>
            <div class="col-md-3">
                <div class="form-group">
                    <label class="d-block">آيا بيماري خاصي داريد؟   </label>
                    <div class="d-inline-block">
                        <input class="custom-input-button" type="radio" v-model="healthCareInfo.hasDisease" value="true" id="sick" @change="changeHasDisease">
                        <label for="sick">بلی</label>
                    </div>
                    <div class="d-inline-block">
                        <input class="custom-input-button" type="radio" v-model="healthCareInfo.hasDisease" value="false" id="not-sick" @change="changeHasDisease">
                        <label for="not-sick">خیر</label>
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-group" v-if="healthCareInfo.hasDisease=='true'">
                    <label>توضیح دهید:</label>
                    <input type="text"
                           v-model="healthCareInfo.specialDisease"
                           :class="[$v.healthCareInfo.specialDisease.$error ?'error-input' :'','form-control']">
                    <span class="help-block" v-if="$v.healthCareInfo.specialDisease.$error && $v.healthCareInfo.specialDisease.$invalid">لطفا بيماري خود را توضیح دهید.</span>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-3">
                <div class="form-group">
                    <label class="d-block">آيا عادت به مصرف دخانيات ، داروي خاص ، ... داريد؟   </label>
                    <div class="d-inline-block">
                        <input class="custom-input-button" type="radio" v-model="healthCareInfo.useTobaccoSpecialMedicine" value="true" id="using-drugs-tobacco" @change="changeUseTobaccoSpecialMedicine">
                        <label for="using-drugs-tobacco">بلی</label>
                    </div>
                    <div class="d-inline-block">
                        <input class="custom-input-button" type="radio" v-model="healthCareInfo.useTobaccoSpecialMedicine" value="false" id="not-addicted" @change="changeUseTobaccoSpecialMedicine">
                        <label for="not-addicted">خیر</label>
                    </div>
                </div>
            </div>
            <div class="col-md-9">
                <div class="form-group" v-if="healthCareInfo.useTobaccoSpecialMedicine=='true'">
                    <label>توضیح دهید:</label>
                    <input type="text"
                           v-model="healthCareInfo.tobaccoSpecialMedicine"
                           :class="[$v.healthCareInfo.tobaccoSpecialMedicine.$error ?'error-input' :'','form-control']">
                    <span class="help-block" v-if="$v.healthCareInfo.tobaccoSpecialMedicine.$error && $v.healthCareInfo.tobaccoSpecialMedicine.$invalid">لطفا توضیح دهید.</span>
                </div>
            </div>
        </div>
        <div class="header">
            <div class="step-ttl">فعالیت‌هاو مهارت‌ها</div>
            <div class="h-border"></div>
        </div>
        <div class="sub-header">
            <div class="step-ttl">
                دوره‌های آموزشی/تخصصی
            </div>
            <div class="h-border"></div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="header-row">
                    <div class="content"><label>نام دوره‌:</label></div>
                    <div class="content"><label>سال‌:</label></div>
                    <div class="content"><label>مدت‌:</label></div>
                    <div class="content"><label>نام كامل موسسه‌:</label></div>
                    <div class="content"><label>محل برگزاری‌:</label></div>
                    <div class="content"><label>گواهي پايان دوره‌:</label></div>
                </div>
            </div>
        </div>
        <div class="field_wrapper2">
            <div class="row">
                <div class="col-md-12">
                    <div class="body-row" v-for="(course, index) in specializedCourses" :key="index">
                        <div class="content">
                            <input class="form-control" type="text" v-model="course.courseName">
                        </div>
                        <div class="content">
                            <input class="form-control" type="text" v-model="course.year">
                        </div>
                        <div class="content">
                            <input class="form-control" type="text" v-model="course.period">
                        </div>
                        <div class="content">
                            <input class="form-control" type="text" v-model="course.instituteName">
                        </div>
                        <div class="content">
                            <input class="form-control" type="text" v-model="course.location">
                        </div>
                        <div class="content">
                            <div class="d-inline-block">
                                <input class="custom-input-button" type="radio" v-model="course.hasDegree" value="true" :id="'certificate'+index">
                                <label :for="'certificate'+index">بلی</label>
                            </div>
                            <div class="d-inline-block">
                                <input class="custom-input-button" type="radio" v-model="course.hasDegree" value="false" :id="'no-certificate'+index">
                                <label :for="'no-certificate'+index">خیر</label>
                            </div>
                        </div>
                        <div class="action-btn" v-if="index !=0">
                            <a href="javascript:void(0);"
                               class="remove_rowbtn"
                               @click="removeCourseInfoRow(index)"
                               title="حذف این سطر"><i class="avafont-minus"></i></a>
                        </div>
                    </div>
                    <div class="action-btn action-btn-pos">
                        <a href="javascript:void(0);"
                           @click="addNewCourseRow()"
                           class="add_rowbtn"
                           v-if="specializedCourses.length<=4"
                           title="افزودن سطر جدید"><i class="avafont-add"></i></a>
                    </div>
                </div>
            </div>
        </div>
        <div class="sub-header">
            <div class="step-ttl">
                مهارت‌ها
            </div>
            <div class="h-border"></div>
        </div>
        <div class="row">
            <div class="col-md-3">
                <div class="form-group">
                    <label>زبان خارجی۱:</label>
                    <input class="form-control" type="text" v-model="skillInfo.firstLanguage">
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-group">
                    <label class="d-block">سطح:</label>
                    <div class="d-inline-block">
                        <input class="custom-input-button" type="radio" v-model="skillInfo.firstLanguageLevel" value="مبتدی" id="elementary">
                        <label for="elementary">مبتدی</label>
                    </div>
                    <div class="d-inline-block">
                        <input class="custom-input-button" type="radio" v-model="skillInfo.firstLanguageLevel" value="متوسط" id="intermediate">
                        <label for="intermediate">متوسط</label>
                    </div>
                    <div class="d-inline-block">
                        <input class="custom-input-button" type="radio" v-model="skillInfo.firstLanguageLevel" value="مسلط" id="advanced">
                        <label for="advanced">مسلط</label>
                    </div>
                </div>
            </div>
            <div class="action-btn col-md-3 d-flex justify-content-end">
                <a href="javascript:void(0);" @click="addNewLang" v-if="!newLang" class="add_rowbtn" title="افزودن سطر جدید"><i class="avafont-add"></i></a>
            </div>
        </div>
        <div class="row" v-if="newLang">
            <div class="col-md-3">
                <div class="form-group">
                    <label>زبان خارجی۲:</label>
                    <input class="form-control" type="text" v-model="skillInfo.secondLanguage">
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-group">
                    <label class="d-block">سطح:</label>
                    <div class="d-inline-block">
                        <input class="custom-input-button" type="radio" v-model="skillInfo.secondLanguageLevel" value="مبتدی" id="secondLanguageLevel-elementary">
                        <label for="secondLanguageLevel-elementary">مبتدی</label>
                    </div>
                    <div class="d-inline-block">
                        <input class="custom-input-button" type="radio" v-model="skillInfo.secondLanguageLevel" value="متوسط" id="secondLanguageLevel-intermediate">
                        <label for="secondLanguageLevel-intermediate">متوسط</label>
                    </div>
                    <div class="d-inline-block">
                        <input class="custom-input-button" type="radio" v-model="skillInfo.secondLanguageLevel" value="مسلط" id="secondLanguageLevel-advanced">
                        <label for="secondLanguageLevel-advanced">مسلط</label>
                    </div>
                </div>
            </div>
            <div class="action-btn col-md-3 d-flex justify-content-end">
                <a href="javascript:void(0);" @click="removeNewLang" class="remove_rowbtn" title="افزودن سطر جدید"><i class="avafont-minus"></i></a>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="form-group">
                    <label class="d-block"> مهارت‌های کامپیوتری:</label>
                    <div class="d-inline-block">
                        <input class="custom-input-button" type="checkbox" v-model="skillInfo.computerSkills" value="POWER POINT" id="POWER POINT">
                        <label for="POWER POINT">POWER POINT</label>
                    </div>
                    <div class="d-inline-block">
                        <input class="custom-input-button" type="checkbox" v-model="skillInfo.computerSkills" value="WORD" id="WORD">
                        <label for="WORD">WORD</label>
                    </div>
                    <div class="d-inline-block">
                        <input class="custom-input-button" type="checkbox" v-model="skillInfo.computerSkills" value="EXCEL" id="EXCEL">
                        <label for="EXCEL">EXCEL</label>
                    </div>
                    <div class="d-inline-block">
                        <input class="custom-input-button" type="checkbox" v-model="skillInfo.computerSkills" value="WINDOWS" id="WINDOWS">
                        <label for="WINDOWS">WINDOWS</label>
                    </div>
                    <div class="d-inline-block">
                        <input class="custom-input-button" type="checkbox" v-model="skillInfo.computerSkills" value="MS PROJECT" id="MS PROJECT">
                        <label for="MS PROJECT">MS PROJECT</label>
                    </div>
                    <div class="d-inline-block">
                        <input class="custom-input-button" type="checkbox" v-model="skillInfo.computerSkills" value="INTERNET" id="INTERNET">
                        <label for="INTERNET">INTERNET</label>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6">
                <div class="form-group">
                    <label>سایر مهارت‌های کامپیوتری كه با آن‌ها آشنايي داريد:</label>
                    <input class="form-control" type="text" v-model="skillInfo.otherComputerSkills">
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-group">
                    <label>سخت افزارهايي كه با آن‌ها آشنايي داريد:</label>
                    <input class="form-control" type="text" v-model="skillInfo.hardwareKnowledge">
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6">
                <div class="form-group">
                    <label>سایر مهارت‌ها(فنی،حرفه‌ایی):</label>
                    <input class="form-control" type="text" v-model="skillInfo.otherTechnicalSkills">
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-group">
                    <label>موفقیت‌های خاص:</label>
                    <input class="form-control" type="text" placeholder="مقالات، تحقیقات، تالیفات، جوايز و ..." v-model="skillInfo.specialSuccess">
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-3">
                <div class="form-group">
                    <label class="d-block">آيا گواهینامه رانندگی داريد؟</label>
                    <div class="d-inline-block">
                        <input class="custom-input-button" type="radio" v-model="skillInfo.hasDrivingLicense" value="true" id="has-drivesLicence" @change="changehasDrivingLicense">
                        <label for="has-drivesLicence">بلی</label>
                    </div>
                    <div class="d-inline-block">
                        <input class="custom-input-button" type="radio" v-model="skillInfo.hasDrivingLicense" value="false" id="doesnt-have-drivesLicence" @change="changehasDrivingLicense">
                        <label for="doesnt-have-drivesLicence">خیر</label>
                    </div>
                </div>
            </div>
            <div class="col-md-9" v-if="skillInfo.hasDrivingLicense=='true'">
                <div class="row">
                    <div class="col-md-4">
                        <div class="form-group">
                            <label>نوع پایه:</label>
                            <input type="text"
                                   v-model="skillInfo.drivingLicenseBase"
                                   :class="[$v.skillInfo.drivingLicenseBase.$error ?'error-input' :'','form-control']">
                            <span class="help-block" v-if="$v.skillInfo.drivingLicenseBase.$error && $v.skillInfo.drivingLicenseBase.$invalid">لطفا نوع پایه را وارد کنید.</span>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group">
                            <label>سال اخذ:</label>
                            <input type="text"
                                   v-model="skillInfo.drivingLicenseYear"
                                   placeholder="مثال: 1390"
                                   :class="[$v.skillInfo.drivingLicenseYear.$error ?'error-input' :'','form-control']">
                            <span class="help-block" v-if="$v.skillInfo.drivingLicenseYear.$error && $v.skillInfo.drivingLicenseYear.$invalid">لطفا سال اخذ را وارد کنید.</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-3">
                <div class="form-group">
                    <label class="d-block">آيا تاكنون سفر خارج از كشور رفته ايد؟</label>
                    <div class="d-inline-block">
                        <input class="custom-input-button" type="radio" v-model="travelAbroad" value="true" id="has-traveled" @change="changeTravelAbroad">
                        <label for="has-traveled">بلی</label>
                    </div>
                    <div class="d-inline-block">
                        <input class="custom-input-button" type="radio" v-model="travelAbroad" value="false" id="doesnt-have-traveled" @change="changeTravelAbroad">
                        <label for="doesnt-have-traveled">خیر</label>
                    </div>
                </div>
            </div>
            <div class="col-md-9" v-if="travelAbroad=='true'">
                <div class="row custom-side-margin" v-for="(info, index) in travelAbroadInfos" :key="index">
                    <div class="col-md-4">
                        <div class="form-group">
                            <label>نام كشور:</label>
                            <input class="form-control" type="text" v-model="info.country">
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group">
                            <label>سال سفر:</label>
                            <input class="form-control" type="text" v-model="info.year">
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group">
                            <label>علت سفر:</label>
                            <input class="form-control" type="text" v-model="info.reason">
                        </div>
                        <div class="custom-action-btn-pos" v-if="index !=0">
                            <a href="javascript:void(0);"
                               class="remove_rowbtn"
                               @click="removeTravelAbroadInfo(index)"
                               title="حذف این سطر"><i class="avafont-minus"></i></a>
                        </div>
                        <div class="custom-action-btn-pos">
                            <a href="javascript:void(0);"
                               v-if="travelAbroadInfos.length<=1"
                               class="add_rowbtn"
                               @click="addTravelAbroadInfo()"
                               title="افزودن سطر جدید"><i class="avafont-add"></i></a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6">
                <div class="form-group">
                    <label class="d-block">
                        فعاليتها و سرگرمي هاي اوقات فراغت:
                    </label>
                    <div class="d-inline-block">
                        <input class="custom-input-button" type="checkbox" v-model="entertainments.reading" id="reading">
                        <label for="reading">مطالعه</label>
                    </div>
                    <div class="d-inline-block">
                        <input class="custom-input-button" type="checkbox" v-model="entertainments.sport" id="sport">
                        <label for="sport">ورزش</label>
                    </div>
                    <div class="d-inline-block">
                        <input class="custom-input-button" type="checkbox" v-model="entertainments.membershipInVariousCenters" id="membership">
                        <label for="membership">عضويت در مراكز مختلف</label>
                    </div>
                    <div class="d-inline-block">
                        <input class="custom-input-button" type="checkbox" v-model="entertainments.charitableActivities" id="charity">
                        <label for="charity">فعالیت در امور خیريه</label>
                    </div>
                    <div class="d-inline-block">
                        <input class="custom-input-button" type="checkbox" v-model="entertainments.otherActivities" id="other-hobbies" @change="changeEntertainmentsOtherActivities">
                        <label for="other-hobbies">ساير</label>
                    </div>
                </div>
            </div>
            <div class="col-md-6" v-if="entertainments.otherActivities=='true'">
                <div class="form-group">
                    <input class="form-control mt-4" type="text" placeholder="توضیح فعالیت ..." v-model="entertainments.others">
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { required, requiredIf } from "vuelidate/lib/validators";
    export default {
        data() {
            return {
                healthCareInfo: {
                    bloodType: "",
                    hasDisease: false,
                    specialDisease: "",
                    useTobaccoSpecialMedicine: false,
                    tobaccoSpecialMedicine: "",
                },
                specializedCourses: [
                    {
                        courseName: "",
                        year: null,
                        period: null,
                        instituteName: "",
                        location: "",
                        hasDegree: false
                    }
                ],
                skillInfo: {
                    firstLanguage: "",
                    firstLanguageLevel: "",
                    secondLanguage: "",
                    secondLanguageLevel: "",
                    computerSkills: [],
                    otherComputerSkills: "",
                    hardwareKnowledge: "",
                    otherTechnicalSkills: "",
                    specialSuccess: "",
                    hasDrivingLicense: false,
                    drivingLicenseBase: "",
                    drivingLicenseYear: null
                },
                entertainments: {
                    reading: false,
                    sport: false,
                    membershipInVariousCenters: false,
                    charitableActivities: false,
                    otherActivities: false,
                    others: ""
                },
                travelAbroadInfos: [
                    {
                        country: "",
                        year: null,
                        reason: ""
                    }
                ],
                newLang: false,
                travelAbroad: false
            }
        },
        validations: {
            healthCareInfo: {
                bloodType: { required },
                specialDisease: {
                    required: requiredIf(function () {
                        return this.healthCareInfo.hasDisease == 'true'
                    })
                },
                tobaccoSpecialMedicine: {
                    required: requiredIf(function () {
                        return this.healthCareInfo.useTobaccoSpecialMedicine == 'true'
                    })
                },
            },
            specializedCourses: [],
            skillInfo: {
                drivingLicenseBase: {
                    required: requiredIf(function () {
                        return this.skillInfo.hasDrivingLicense == 'true'
                    })
                },
                drivingLicenseYear: {
                    required: requiredIf(function () {
                        return this.skillInfo.hasDrivingLicense == 'true'
                    })
                }
            },
            entertainments: {},
            travelAbroadInfos: [],
            form: ['healthCareInfo', 'specializedCourses', 'skillInfo', 'entertainments', 'travelAbroadInfos']

        },
        methods: {
            validate() {
                this.$v.form.$touch();
                var isValid = !this.$v.form.$invalid
                this.$emit('on-validate', this.$data, isValid)
                return isValid
            },
            changeHasDisease() {
                this.healthCareInfo.specialDisease = '';
            },
            changeUseTobaccoSpecialMedicine() {
                this.healthCareInfo.tobaccoSpecialMedicine = '';
            },
            addNewCourseRow() {
                const courseInfo = {
                    courseName: "",
                    year: null,
                    period: null,
                    instituteName: "",
                    location: "",
                    hasDegree: false
                };
                this.specializedCourses.push(courseInfo);
            },
            removeCourseInfoRow(index) {
                this.specializedCourses.splice(index, 1);
            },
            addNewLang() {
                this.newLang = true;
            },
            removeNewLang() {
                this.newLang = false;
                this.skillInfo.secondLanguage = '';
                this.skillInfo.secondLanguageLevel = '';
            },
            changehasDrivingLicense() {
                this.skillInfo.drivingLicenseBase = '';
                this.skillInfo.drivingLicenseYear = '';
            },
            changeEntertainmentsOtherActivities() {
                this.entertainments.others = '';
            },
            changeTravelAbroad() {
                this.entertainments.others = '';

            },
            addTravelAbroadInfo() {
                const travelInfo = {
                    country: "",
                    year: null,
                    reason: ""
                };
                this.travelAbroadInfos.push(travelInfo);
            },
            removeTravelAbroadInfo(index) {
                this.travelAbroadInfos.splice(index, 1);
            }
        }
    }
</script>